import { createFileRoute } from "@tanstack/react-router";

import { AdminGuard } from "@/components/admin/AdminGuard";
import { AdminUsersPage } from "@/components/admin/AdminUsersPage";

export const Route = createFileRoute("/admin/users")({
  component: AdminUsersListRoute,
});

function AdminUsersListRoute() {
  return (
    <AdminGuard>
      <AdminUsersPage />
    </AdminGuard>
  );
}
